"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var apiGroupSelectors = _interopRequireWildcard(require("../../../../api-group/store/selectors"));
var _constants = require("../../Terms/constants");
var _TermsModal = _interopRequireDefault(require("../TermsModal"));
var _AcceptTerms = _interopRequireDefault(require("./AcceptTerms"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var API_GROUPS_TERMS = 'By requesting access to this API Group, you accept the terms and conditions of all its APIs.';
var mapStateToProps = function mapStateToProps(state, _ref) {
  var asset = _ref.asset;
  var groupId = asset.groupId,
    assetId = asset.assetId,
    version = asset.version,
    versionGroup = asset.versionGroup,
    type = asset.type;
  var isAPIGroup = type === 'api-group';
  var hasTermsPage = (_exchangeUiPortalsStore.selectors.selectPages(state, {
    groupId: groupId,
    assetId: assetId,
    version: version
  }) || []).some(function (page) {
    return page.path === _constants.TERMS_PAGE_PATH;
  });
  var hasUnderlyingTerms = isAPIGroup && apiGroupSelectors.hasUnderlyingTerms(state, {
    groupId: groupId,
    assetId: assetId,
    versionGroup: versionGroup
  });
  return {
    hasTerms: hasTermsPage || hasUnderlyingTerms,
    isAPIGroup: isAPIGroup
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var asset = _ref2.asset,
    pushModal = _ref2.pushModal,
    renderUnderlyingTerms = _ref2.renderUnderlyingTerms;
  return {
    onShowTermsClick: function onShowTermsClick(apiGroupInstanceId) {
      return pushModal(_TermsModal.default, {
        apiGroupInstanceId: apiGroupInstanceId,
        asset: asset,
        renderUnderlyingTerms: renderUnderlyingTerms,
        defaultTermsMarkdown: asset.type === 'api-group' ? API_GROUPS_TERMS : ''
      });
    }
  };
};
var AcceptTermsContainer = (0, _redux.compose)(_exchangeReactHooks.withModal, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_AcceptTerms.default);

// we'll need that to live
AcceptTermsContainer.isFormComponent = true;
var _default = exports.default = AcceptTermsContainer;
//# sourceMappingURL=AcceptTerms.container.js.map